import React, { useEffect } from "react";
import {
  I2cIconButton,
  I2cButton,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { UserStateContext } from "../../Context/AuthContext";
import { useLocation } from "react-router-dom";

const DarkModeBtn = () => {
  const { darkMode, setDarkMode } = UserStateContext();
  const location = useLocation(); // Import and use useLocation hook

  useEffect(() => {
    const htmlTag = document.querySelector("html");
    if (darkMode) {
      htmlTag.classList.add("i2c-theme-dark");
    } else {
      htmlTag.classList.remove("i2c-theme-dark");
    }
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  const authPages =
    location.pathname.includes("/login") ||
    location.pathname.includes("/forgot-password") ||
    location.pathname.includes("/reset-password/") ||
    location.pathname.includes("/reset-success");

  return (
    <>
      {authPages ? (
        <I2cButton
          variant="secondary gray"
          size="x-small"
          onClick={() => setDarkMode(!darkMode)}
        >
          <I2cIcon
            name={`${darkMode ? "linear-sun-1" : "linear-moon"}`}
            label=""
          ></I2cIcon>
        </I2cButton>
      ) : (
        <I2cIconButton
          name={`${darkMode ? "linear-sun-1" : "linear-moon"}`}
          onClick={() => setDarkMode(!darkMode)}
        ></I2cIconButton>
      )}
    </>
  );
};

export default DarkModeBtn;
